/* ============================================
   GENTLE MONSTER INSPIRED THEME JS
   ============================================ */

(function () {
  'use strict';

  // ——————————————————————————————————————————
  // Header: transparent on hero, solid on scroll
  // ——————————————————————————————————————————
  const header = document.querySelector('.site-header');
  const heroSection = document.querySelector('.hero');

  function updateHeader() {
    if (!header) return;
    if (heroSection) {
      const scrolled = window.scrollY > 20;
      header.classList.toggle('transparent', !scrolled);
    }
  }

  if (heroSection) {
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  // ——————————————————————————————————————————
  // Mega Menu
  // ——————————————————————————————————————————
  const navLinks = document.querySelectorAll('.header__nav-link[data-menu]');
  const megaMenus = document.querySelectorAll('.mega-menu');
  let menuTimeout;

  navLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      clearTimeout(menuTimeout);
      const target = link.dataset.menu;
      megaMenus.forEach(m => {
        m.classList.toggle('is-open', m.dataset.menu === target);
      });
    });

    link.addEventListener('mouseleave', () => {
      menuTimeout = setTimeout(() => {
        megaMenus.forEach(m => m.classList.remove('is-open'));
      }, 200);
    });
  });

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => clearTimeout(menuTimeout));
    menu.addEventListener('mouseleave', () => {
      menuTimeout = setTimeout(() => {
        megaMenus.forEach(m => m.classList.remove('is-open'));
      }, 200);
    });
  });

  // ——————————————————————————————————————————
  // Search overlay
  // ——————————————————————————————————————————
  const searchOverlay = document.querySelector('.search-overlay');
  const searchTriggers = document.querySelectorAll('[data-search-open]');
  const searchClose = document.querySelector('.search-overlay__close');
  const searchInput = document.querySelector('.search-overlay__input');

  searchTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      searchOverlay?.classList.add('is-open');
      setTimeout(() => searchInput?.focus(), 100);
    });
  });

  searchClose?.addEventListener('click', () => {
    searchOverlay?.classList.remove('is-open');
  });

  searchOverlay?.addEventListener('click', e => {
    if (e.target === searchOverlay) searchOverlay.classList.remove('is-open');
  });

  // ——————————————————————————————————————————
  // Cart drawer
  // ——————————————————————————————————————————
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    cartOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ——————————————————————————————————————————
  // Wishlist toggle (visual only — hook to Shopify wishlist app as needed)
  // ——————————————————————————————————————————
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
    });
  });

  // ——————————————————————————————————————————
  // Quick Add to Cart
  // ——————————————————————————————————————————
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (res.ok) {
          btn.textContent = 'Added';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            openCart();
          }, 800);
        }
      } catch {
        btn.textContent = originalText;
      }
    });
  });

  // ——————————————————————————————————————————
  // Cart count updater
  // ——————————————————————————————————————————
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.header__cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch (_) {}
  }

  updateCartCount();

  // ——————————————————————————————————————————
  // Lazy image loading with skeleton
  // ——————————————————————————————————————————
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          img.classList.remove('img-loading');
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('img[data-src]').forEach(img => {
      img.classList.add('img-loading');
      imgObserver.observe(img);
    });
  }

  // ——————————————————————————————————————————
  // Escape key closes all overlays
  // ——————————————————————————————————————————
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      searchOverlay?.classList.remove('is-open');
      closeCart();
      megaMenus.forEach(m => m.classList.remove('is-open'));
    }
  });

})();
